import React from 'react';

import { useHandlerAdapter } from './checkbox.helpers';
import {
  CheckboxBox,
  CheckboxField,
  CheckboxIcon,
  CheckboxInner,
  CheckboxText,
} from './checkbox.styles';
import { CheckboxProps } from './checkbox.types';

export function Checkbox<Value extends unknown>(props: CheckboxProps<Value>): JSX.Element | null {
  const {
    boxRef,
    fieldRef,
    name,
    value,
    placeholder,
    isChecked,
    isDisabled,
    isErrored,
    onChange,
    onFocus,
    onBlur,
    children,
    ...rest
  } = props;

  const onChangeHandler = useHandlerAdapter(value, onChange);
  const onFocusHandler = useHandlerAdapter(value, onFocus);
  const onBlurHandler = useHandlerAdapter(value, onBlur);

  return (
    <CheckboxBox {...rest} ref={boxRef}>
      <CheckboxField
        ref={fieldRef}
        name={name}
        type="checkbox"
        value={`${value}`}
        placeholder={placeholder}
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChangeHandler}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
      />
      <CheckboxInner>
        <CheckboxIcon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0303 8.46967C18.3232 8.76256 18.3232 9.23744 18.0303 9.53033L11.0303 16.5303C10.7374 16.8232 10.2626 16.8232 9.96967 16.5303L6.96967 13.5303C6.67678 13.2374 6.67678 12.7626 6.96967 12.4697C7.26256 12.1768 7.73744 12.1768 8.03033 12.4697L10.5 14.9393L16.9697 8.46967C17.2626 8.17678 17.7374 8.17678 18.0303 8.46967Z" fill="currentColor" />
          </svg>
        </CheckboxIcon>
        <CheckboxText>
          {children}
        </CheckboxText>
      </CheckboxInner>
    </CheckboxBox>
  );
}
